var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-details-image-container"},[_c('img',{staticClass:"product-details-image aspect-square",attrs:{"src":_vm.activeImage.mimeSource[_vm.language]}}),_c('div',{staticClass:"product-image-selector"},_vm._l((_vm.mimes),function(m){return _c('img',{key:m.index,class:[
        'product-details-image-preview',
        _vm.activeImage.index === m.index ? 'active' : '',
      ],attrs:{"src":m.mimeSource[_vm.language]},on:{"click":function($event){return _vm.setActive(m.index)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }